/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import "core-js/stable";
import "regenerator-runtime/runtime";
import 'isomorphic-unfetch'

import Vue from 'vue'
import App from '../app.vue'
import FullWidthBanner from './components/global/FullWidthBanner'
import Footer from './components/global/Footer'
import { router } from './router/router'
import store from './store';
import { config } from './config/config'

// Apollo
import VueApollo from 'vue-apollo'
import {apolloApiClient, apolloClient} from './config/apollo'
const apolloProvider = new VueApollo({
  clients: {
    default: apolloClient,
    apiClient: apolloApiClient
  },
  defaultClient: apolloClient,
})
Vue.use(VueApollo)
// Apollo

// moment
import moment from 'vue-moment'
Vue.use(moment)
// moment

// google analytics
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: config.google_analytics_id,
    params: {
      send_page_view: false
    }
  }
});
// google analytics

import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

// VueScrollTo
const VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 300,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
// VueScrollTo


document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#vue-app',
    router,
    apolloProvider,
    store,
    // i18n: i18n,
    render: h => h(App)
  })
  // new Vue({
  //   el: '#vue-full-width-banner1',
  //   router,
  //   apolloProvider,
  //   store,
  //   // i18n: i18n,
  //   render: h => h(FullWidthBanner)
  // })
  // new Vue({
  //   el: '#vue-full-width-banner2',
  //   router,
  //   apolloProvider,
  //   store,
  //   // i18n: i18n,
  //   render: h => h(FullWidthBanner)
  // })
  new Vue({
    el: '#vue-footer',
    router,
    apolloProvider,
    store,
    // i18n: i18n,
    render: h => h(Footer)
  })
})

